import { Factory } from 'miragejs';

export default Factory.extend({
  afterCreate(geometry, server) {
    geometry.update({
      type: 'polygon',
      coordinates: server.createList('graphql/coordinate', 4, { x: 0.5, y: 0.5 }),
      center: server.create('graphql/center', { x: 0.5, y: 0.5 }),
    });
  },
});
